import { ServiceGroupRate } from '@quorum/models/xs-resource';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface ServiceGroupRatesState extends EntityState<ServiceGroupRate> {}

export const serviceGroupRatesAdapter: EntityAdapter<ServiceGroupRate> = createEntityAdapter<ServiceGroupRate>({
  selectId: (serviceGroupRate: ServiceGroupRate) => serviceGroupRate.id
});

export const initialState: ServiceGroupRatesState = serviceGroupRatesAdapter.getInitialState({});
export const servicesGroupRatesFeatureSelector = createFeatureSelector<any>('labourOperations');
export const serviceGroupRatesSelector = createSelector(
  servicesGroupRatesFeatureSelector,
  (state: any) => state.rates
);
export const { selectIds, selectEntities, selectAll, selectTotal } = serviceGroupRatesAdapter.getSelectors(
  serviceGroupRatesSelector
);
